import {
  browserDetection,
  MatchHeightDirective,
} from '@myre/ui-primitive-core';
import {
  LayoutColumnComponent,
  LayoutRowContainerComponent,
} from '@myre/ui-primitive-layouts';

import {
  ChangeDetectorRef,
  Component,
  HostListener,
  inject,
} from '@angular/core';

import {
  type INavbarConfig,
  type INavbarResponsiveLayout,
} from './navbar.interfaces';
import { NAVBAR_CONFIG } from './providers/navbar-config';

@Component({
  selector: 'myre-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  imports: [
    LayoutRowContainerComponent,
    LayoutColumnComponent,
    MatchHeightDirective,
  ],
})
export class NavbarComponent {
  public config = inject<INavbarConfig>(NAVBAR_CONFIG);
  private _changeDetectionRef = inject(ChangeDetectorRef);

  public get isDesktop(): boolean {
    return browserDetection.isDesktop;
  }

  public get isTablet(): boolean {
    return browserDetection.isTablet;
  }

  public get isPhone(): boolean {
    return browserDetection.isPhone;
  }

  public get layout(): INavbarResponsiveLayout {
    return this.config.layout;
  }

  @HostListener('window:resize.out-zone')
  public detectChanges(): void {
    this._changeDetectionRef.detectChanges();
  }
}
